import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {   
    FaBoxOpen,  
    FaCircleXmark,
    FaFileArrowDown,
    FaTrashCan 
} from 'react-icons/fa6'
import { BsBoxSeamFill } from "react-icons/bs"
import { PiBoxArrowDownFill } from "react-icons/pi"
//import { ImBoxAdd } from "react-icons/im";

import { formatFileSize } from '../../utils/formatting'
import { getDetailsUrl, pushHistoryWithDownload, urls } from '../../utils/routing'
//import { multiDownload } from '../../utils/functions'

import ButtonBlueSmall from '../Buttons/ButtonBlueSmall/ButtonBlueSmall'

import { 
    BASKET_HEADER, 
    BASKET_ISDOWNLOADING, 
    BASKET_NULL_CONTENT, 
    BASKET_NULL_TITLE, 
    BUTTON_ALL_LOAD, 
    MOD_VERSION,
    TITLE_ALL_SIZE
} from './translations'

import styles from './ShopBasket.module.css';

export default class ShopBasket extends Component {
    static propTypes = {
        orders: PropTypes.arrayOf(PropTypes.shape({
            cover: PropTypes.string,
            gameVersion: PropTypes.string,
            isDownloadDisabled: PropTypes.bool,
            id: PropTypes.number,
            modSize: PropTypes.number,
            modVersion: PropTypes.string,
            modVersionFile: PropTypes.string, // donwloadUrl for this mod
            title: PropTypes.string,
        })).isRequired,

        isAnimate: PropTypes.bool,
        
        isDisabled: PropTypes.bool,
        isDownloading: PropTypes.bool,

        deleteOrder: PropTypes.func,
        clearCart: PropTypes.func,
    }

    constructor(props) {
        super(props)
        this.state = {
            basketIsOpened: false // show or hide cart
        }
    }

    handleClickBasketShow = () => {
        this.setState({basketIsOpened: true});
    }

    handleClickBasketHide = () => {
        this.setState({basketIsOpened: false});
    }

    handleClickDownload = () => {
        let newOrders = []
        this.props.orders.forEach(el => newOrders.push({'originalFileName': el.modVersionFile.slice(38), 'title': el.title}))
        let basketItems = {
            basket_items: newOrders,
        }
        // ['title'=>'Nazvanie0123456789qwerty', 'originalFileName'=>'updater_tSF03oXwe.rar']
        
        pushHistoryWithDownload(this.props.history, basketItems)
    }

    handleClickDeleteItem = (id) => {
        this.props.deleteOrder(id)
    }

    handleClickBasketIsDownload = () => {
        return alert(BASKET_ISDOWNLOADING)
    }

    renderBasketCartItem(item) {
        return (
            <li className={styles.item} key={item.id}>
                {/* <div className={styles.artwork}>
                    <img src={item.img} alt="Cart item artwork" errorimage="/assets/img/placeholders/bs-default-placeholder.svg" className={styles.ng_lazyloaded} />
                </div> */}
                <div className={styles.details}>
                    <div className={styles.title_size}>
                        <a className={styles.title} href={getDetailsUrl(item.id)} rel="noreferrer" target="_blank" title={item.title}> {item.title} </a>
                        <div className={styles.wrapper_size}>
                            <span className={styles.size}> {formatFileSize(item.modSize)} </span>
                            <div className={styles.remove_item}>
                                <div type="button" aria-label="Remove from cart" onClick={() => this.handleClickDeleteItem(item.id)} style={{maxWidth:'20px',maxHeight:'20px'}}>
                                    <FaTrashCan className={styles.basket_btn__cart_delete} />
                                    {/* <i className={classNames(styles.vb_icon_close_m_medium_solid, styles.vb_icon_m)} role="presentation"></i> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.type}>
                        <span className={styles.version_type}>{MOD_VERSION(item.modVersion)}</span>
                        {/* <span className={styles.product_type}>Обновлено: {item.updatedAt ? formatDate(item.updatedAt, 'DD MMM YYYY г.') : `xxx`}</span> */}
                    </div>
                </div>
            </li>
        )
    }

    getAllSizes() {
        let allSizes = 0
        this.props.orders.forEach(el => allSizes += el.modSize)

        return allSizes
    }

    renderBasketCart() {
        //let allSizes = 0
        //this.props.orders.forEach(el => allSizes += el.modSize)
        return this.state.basketIsOpened ? (
            <div className={styles.basket_cart}>
                <header>
                    {BASKET_HEADER}
                    {this.props.orders.length > 0 ? (
                        <span className={styles.cart_count}>&nbsp;{`(${this.props.orders.length})`}</span>
                    ) : ( 
                        null 
                    )}
                    <FaCircleXmark className={styles.basket_cart__btn_close} onClick={ this.handleClickBasketHide } />
                </header>
                <div className={styles.basket_cart__body}>
                    {this.props.orders.length === 0 ? (
                        <div className={classNames(styles.cart_empty_content, styles.vb_icon_55)} style={{}}>
                            <i className={classNames(styles.empty_icon, styles.vb_icon_shop_bag_m_regular)} role="presentation"></i>
                            <p className={styles.cart_title} role="heading" aria-level="2">{BASKET_NULL_TITLE}</p>
                            <p className={styles.cart_description}>{BASKET_NULL_CONTENT}</p>
                        </div>
                    ) : (
                        null
                    )}
                </div>
                <div className={styles.cart_items}>
                    {this.props.orders.length !== 0 ? (
                        <ul role="presentation">
                            {this.props.orders.map((item) => this.renderBasketCartItem(item))}
                        </ul>
                    ) : (
                        <ul role="presentation"></ul>
                    )}
                </div>
                {this.props.orders.length !== 0 ? (
                    <div className={classNames(styles.basket_cart__btn)}>
                        <ButtonBlueSmall glitch={true} onClick={this.handleClickDownload}>{BUTTON_ALL_LOAD}</ButtonBlueSmall>
                    </div>
                ) : (
                    <div className={classNames(styles.basket_cart__btn, styles.cart_button__null)}>
                        <ButtonBlueSmall glitch={true} onClick={this.handleClickDownload}>{BUTTON_ALL_LOAD}</ButtonBlueSmall>
                    </div>
                )}
                {this.props.orders.length > 0 ? (
                    <div className={styles.concat_sizes}>{TITLE_ALL_SIZE(this.getAllSizes())}</div>
                ) : (
                    null
                )}
            </div>
        ) : (
            null
        )
    }

    render() {
        const basketStyle = classNames(styles.basket, {
            [styles.active]: this.state.basketIsOpened, 
            [styles.isDisabled]: this.props.isDisabled,
        })
        const basketBtnStyle = classNames(styles.basket_btn, {
            [styles.isAnimate]: this.props.isAnimate,
        })

        return this.props.location.pathname === urls.landing ? 
            this.props.isDownloading ? (
                <div className={basketStyle}>
                    <div className={styles.basket_btn} onClick={ this.handleClickBasketIsDownload }>
                        <PiBoxArrowDownFill className={styles.basket_btn__img} />
                    </div>
                </div>
            ) : (
                <div className={basketStyle}>
                    <div className={basketBtnStyle} onClick={ this.handleClickBasketShow }>
                        {(this.getAllSizes() >= 500000000 || this.props.orders.length === 10) || (this.getAllSizes() >= 500000000 && this.props.orders.length === 10) ? (
                            <BsBoxSeamFill className={styles.basket_btn__img} />
                        ) : (
                            this.props.isAnimate ? (<>
                                    <FaFileArrowDown className={styles.animate_icon} />
                                    <FaBoxOpen className={styles.basket_btn__img} />
                                </>) : <FaBoxOpen className={styles.basket_btn__img} />
                        )}
                        {this.props.orders.length > 0 ? (
                            <span className={styles.basket_count}>{`(${this.props.orders.length})`}</span>
                        ) : ( 
                            null 
                        )}
                    </div>
                    {this.renderBasketCart()}
                </div>
            ) 
            : null
    }
}
